import { Box, Container, Typography } from "@mui/material";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import CheckroomIcon from "@mui/icons-material/Checkroom";
import DryCleaningIcon from "@mui/icons-material/DryCleaning";
import FavoriteIcon from "@mui/icons-material/Favorite";
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import serviceCardBg from "../../assets/images/service_card_bgd.png";
import servicesSectionBg from "../../assets/images/services_section_bg.png";
import ContentCutIcon from "@mui/icons-material/ContentCut";

const garmentServices = [
  {
    icon: <DryCleaningIcon />,
    title: "Dry Cleaning",
    items: [
      "Shirts & Tops",
      "Suits & Blazers",
      "Dresses & Sarees",
      "Winter Coats",
    ],
  },

  {
    icon: <LocalLaundryServiceIcon />,
    title: "Laundry Service",
    items: ["Wash & Fold", "Steam Ironing", "Bed Linens", "Everyday Clothing"],
  },

  {
    icon: <ContentCutIcon />,
    title: "Alterations",
    items: [
      "Hemming",
      "Length Adjustment",
      "Garment Repairs",
      "Custom Alterations",
    ],
  },

  {
    icon: <FavoriteIcon />,
    title: "Wedding Dress Care",
    items: [
      "Wedding Dresses",
      "Bridal Gowns",
      "Preservation",
      "Delicate Fabrics",
    ],
  },
];

export default function PremiumGarmentCare() {
  return (
    <Box
      sx={{
        py: {
          xs: 4,
          md: 6,
        },

        position: "relative",

        overflow: "hidden",

        backgroundImage: `url(${servicesSectionBg})`,

        backgroundSize: "cover",

        backgroundPosition: "center",
      }}
    >
      <Container maxWidth="xl">
        {/* HEADER */}

        <Box
          sx={{
            textAlign: "center",

            maxWidth: "850px",

            mx: "auto",
          }}
        >
          <Box
            sx={{
              display: "inline-flex",

              px: 2.5,

              py: 1,

              borderRadius: "50px",

              background: "rgba(0,87,255,.08)",

              color: "#0057FF",

              fontSize: "12px",

              fontWeight: 800,

              letterSpacing: "1px",

              textTransform: "uppercase",
            }}
          >
            Premium Garment Care
          </Box>

          <Typography
            sx={{
              mt: 1.5,

              fontWeight: 900,

              lineHeight: 1.1,

              color: "#07122F",

              fontSize: {
                xs: "32px",
                sm: "32px",
                md: "56px",
                lg: "56px",
              },
              display: "block",
            }}
          >
            Professional Cleaning {/* <br /> */}
            <Box
              component="span"
              sx={{
                background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                WebkitBackgroundClip: "text",

                WebkitTextFillColor: "transparent",
              }}
            >
              Solutions
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 2,

              maxWidth: "700px",

              mx: "auto",

              color: "#64748B",

              lineHeight: 1.8,

              fontSize: {
                xs: "13px",
                sm: "14px",
                md: "16px",
              },
            }}
          >
            Expert garment care services for everyday clothing, luxury jackets,
            wedding dresses and formal wear. Trusted cleaning solutions with
            professional attention to every detail.
          </Typography>
        </Box>

        {/* CARDS */}

        <Box
          sx={{
            mt: {
              xs: 5,
              md: 8,
            },

            display: "flex",

            flexWrap: "wrap",

            justifyContent: "center",

            gap: 2,
          }}
        >
          {garmentServices.map((item, index) => (
            <Box
              key={index}
              sx={{
                flex: {
                  xs: "0 0 calc(50% - 8px)",
                  lg: "0 0 calc(25% - 15px)",
                },

                maxWidth: {
                  xs: "calc(50% - 8px)",
                  lg: "calc(25% - 15px)",
                },

                minHeight: {
                  xs: 220,
                  md: 340,
                },

                p: {
                  xs: 1.5,
                  md: 3,
                },

                position: "relative",

                overflow: "hidden",

                borderRadius: "30px",

                backgroundImage: `
        //   linear-gradient(
        //     rgba(255,255,255,.92),
        //     rgba(248,251,255,.85)
        //   ),
          url(${serviceCardBg})
        `,

                backgroundSize: "cover",

                backgroundPosition: "center",

                backdropFilter: "blur(18px)",

                border: "1px solid rgba(255,255,255,.75)",

                boxShadow:
                  "0 15px 40px rgba(0,87,255,.08), inset 0 1px 0 rgba(255,255,255,.9)",

                transition: ".35s",

                "&::before": {
                  content: '""',

                  position: "absolute",

                  left: 0,

                  top: 18,

                  bottom: 18,

                  width: "4px",

                  borderRadius: "20px",

                  background: "linear-gradient(180deg,#0057ff,#4da3ff,#0057ff)",

                  transition: ".3s",
                },

                "&:hover": {
                  transform: "translateY(-8px)",

                  boxShadow: "0 25px 60px rgba(0,87,255,.14)",

                  "&::before": {
                    width: "6px",
                  },
                },
              }}
            >
              {/* ICON */}

              <Box
                sx={{
                  width: {
                    xs: 46,
                    md: 68,
                  },

                  height: {
                    xs: 46,
                    md: 68,
                  },

                  borderRadius: "20px",

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "center",

                  background: "linear-gradient(135deg,#0057ff,#2f8cff)",

                  boxShadow: "0 12px 30px rgba(0,87,255,.25)",

                  border: "2px solid rgba(255,255,255,.5)",

                  color: "#fff",

                  mb: 2.5,

                  "& svg": {
                    fontSize: {
                      xs: 24,
                      md: 34,
                    },
                  },
                }}
              >
                {item.icon}
              </Box>

              {/* TITLE */}

              <Typography
                sx={{
                  fontWeight: 800,

                  color: "#07122F",

                  lineHeight: 1.2,

                  fontSize: {
                    xs: "13px",
                    md: "24px",
                  },
                }}
              >
                {item.title}
              </Typography>

              {/* SERVICES */}

              <Box
                sx={{
                  mt: 2,

                  display: "flex",

                  flexDirection: "column",

                  gap: 1,
                }}
              >
                {item.items.map((service, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: "flex",

                      alignItems: "center",

                      gap: 0.8,
                    }}
                  >
                    <CheckCircleIcon
                      sx={{
                        color: "#0057FF",

                        fontSize: {
                          xs: 14,
                          md: 18,
                        },
                      }}
                    />

                    <Typography
                      sx={{
                        color: "#12305F",

                        fontWeight: 600,

                        lineHeight: 1.4,

                        fontSize: {
                          xs: "10px",
                          md: "15px",
                        },
                      }}
                    >
                      {service}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {/* BOTTOM GRADIENT */}

              <Box
                sx={{
                  position: "absolute",

                  left: 0,

                  right: 0,

                  bottom: 0,

                  height: "4px",

                  background: "linear-gradient(90deg,#0057FF,#1DB6FF)",
                }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
